export const transactionTypes = [
  { id: "expense", name: "Expense", operator: "-", color: "text-red-500" },
  { id: "income", name: "Income", operator: "+", color: "text-green-500" },
];
